/**
 * When a newly deployed build may reload the page.
 *
 * `registerType: 'autoUpdate'` makes vite-plugin-pwa call
 * `window.location.reload()` the moment a new service worker activates. A
 * returning visitor loads the old build from the precache, the new worker
 * installs in the background, and seconds later the page reloads under them.
 * In staging that wiped a student's first message mid-conversation and left
 * the Connect contact it had started waiting, unanswered, until the flow timed
 * out.
 *
 * So the reload only happens while nothing is at stake. Once the student has
 * typed or sent anything, the update is left for their next visit: the new
 * worker already controls the page, so the next load serves the new build.
 */

let conversationInProgress = false;

/** The chat reports whether reloading now would lose anything the student wrote. */
export function setConversationInProgress(inProgress: boolean): void {
	conversationInProgress = inProgress;
}

/** `onNeedReload` for `registerSW`: reload only if it costs the student nothing. */
export function handleServiceWorkerUpdate(
	reload: () => void = () => window.location.reload(),
): void {
	if (conversationInProgress) return;
	reload();
}
